import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import FileUploadIcon from 'app/components/Icons/FileUploadIcon';
import {
  deleteBtn,
  fileBox,
  fileDetailsBox,
  fileDetailsInfo,
  fileDetailsInfoSize,
  fileDetailsSpanInfo,
  fileSizeText,
  header,
  inputProps,
  leftSide,
  leftSideFileInfo,
  uploadBox,
} from './CustomFileUpload.sx';
import DocumentIcon from 'app/components/Icons/DocumentIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import useCustomFileUpload from 'app/components/CustomFileUpload/useCustomFileUpload';
import { useDropzone } from 'react-dropzone';

interface Props {
  fileSize: string;
  withOutLabel?: boolean;
  withOutDetails?: boolean;
  name?: any;
  file?: any;
  onDrop?: any;
  deleteFile?: any;
  errorFileSize?: boolean;
}

const FileUpload = (props: Props) => {
  const { fileSize, withOutLabel, withOutDetails, name, file, onDrop, deleteFile, errorFileSize } = props;
  // const { onDrop } = props;

  const { formatBytes, getRootProps, getInputProps } = useCustomFileUpload({ onDrop });

  // const { getRootProps, getInputProps } = useDropzone({
  //   onDrop,
  //   multiple: false,
  //   maxSize: 30000000,
  //   accept: {
  //     'image/*': ['.jpg', '.jpeg', '.png'],
  //     'application/pdf': ['.pdf'],
  //   },
  // });

  // const files = acceptedFiles.map((file: any) => (
  //   <li key={file?.path}>
  //     {file?.path} - {file.size} bytes
  //   </li>
  // ));

  return (
    <Box>
      {!withOutLabel && <Typography sx={header}>Ələvələr</Typography>}
      <div {...getRootProps()} style={{ width: '100%' }}>
        <Box sx={uploadBox}>
          <FileUploadIcon />
          Faylı seçin və ya buraya sürüşdürün
          <input type="file" {...getInputProps()} style={inputProps} />
        </Box>
      </div>
      {!withOutDetails && (
        <Box sx={fileDetailsBox}>
          <Typography sx={fileDetailsInfo}>
            Yükləmə üçün icaze verilmiş formatlar:
            <Typography component={'span'} sx={fileDetailsSpanInfo}>
              &nbsp;*.pdf, *.png, *.jpg/*.jpeg.
            </Typography>
          </Typography>
          <Typography sx={fileDetailsInfoSize(errorFileSize)}>
            Bir faylın maksimal ölçüsü:
            <Typography component={'span'} sx={fileDetailsSpanInfo}>
              {` ${fileSize}`}
            </Typography>
          </Typography>
        </Box>
      )}
      {file?.length > 0 &&
        file.map((item: any, index: number) => (
          <Box sx={fileBox} key={index}>
            <Box sx={leftSide}>
              <DocumentIcon />
              <Box sx={leftSideFileInfo}>
                <Typography sx={{ lineHeight: '1', fontWeight: '500' }}>{item.name}</Typography>
                <Typography sx={fileSizeText}>{formatBytes(item.size)}</Typography>
              </Box>
            </Box>
            <Button color={'tertiary'} sx={deleteBtn} onClick={() => deleteFile(index)}>
              <BinIcon />
            </Button>
          </Box>
        ))}
    </Box>
    // <section className="container">
    //   <div {...getRootProps({ className: 'dropzone' })}>
    //     <input {...getInputProps()} />
    //     <p>Drag n drop some files here, or click to select files</p>
    //   </div>
    //   <aside>
    //     <h4>Files</h4>
    //     <ul>{files}</ul>
    //   </aside>
    // </section>
  );
};

export default FileUpload;
